import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send-sharp",
  "use": "icon-send-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-send-sharp\"><title>Send</title><path d=\"M16 464l480-208L16 48v160l320 48-320 48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol